import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-tree',
  templateUrl: './page-tree.component.html',
  styleUrls: ['./page-tree.component.scss']
})
export class PageTreeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
